export default class FileManager {
    constructor(file) {
        this._file = file;
    }

    set file(value) {
        this._file = value;
    }

    get file() {
        return this._file;
    }

    async readBinaryContents() {
        
        const promise = new Promise((resolve, reject) => {
            const fileReader = new FileReader();

            fileReader.onload = (contents) => {
                let data = contents.target.result;
                const pos = data.indexOf(",");
                if (pos) {
                    data = data.substring(pos + 1);
                }
                resolve(data);
            };
            fileReader.onerror = reject;

            fileReader.readAsDataURL(this._file);
        });

        return promise;
    }

    fileSizeHuman() {
        let fileSize = this._file.size;
        let output = `${fileSize} bytes`;

        for (let multiples = ["KiB", "MiB", "GiB", "TiB", "PiB", "EiB", "ZiB", "YiB"], 
                 multiple = 0, 
            approx = fileSize / 1024; 
            approx > 1; 
            approx /= 1024, multiple++) {
            
            output = approx.toFixed(3) + " " + multiples[multiple] + " (" + fileSize + " bytes)";
        }

        return output;
    }
}